module.exports = __webpack_public_path__ + "assets/media/mike-volpe.242e8f3c.svg";